import { BasePolicyStatus } from '../../../../../../coverpath-common/angular/components/account-center/policy-status/base-policy-status';
import { Product } from '../../../../../../common/js/static/Product';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { CoverpathAnnuity } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathAnnuity';
import { UICategory, UILoggerSingleton } from '../../../../../../common/js/logger/UILoggerSingleton';
export class CoverpathAnnuityStatus extends BasePolicyStatus {
  policy: CoverpathAnnuity;

  constructor(protected amorphicService: AmorphicService, policy: CoverpathAnnuity) {
    super(amorphicService, policy);
    this.policy = policy as CoverpathAnnuity;
    this.setAllProperties();
  }

  setAllProperties() {
    this.isJointApp = false;
    this.advisorSignedApp = this.policy.application.agentEsignComplete;
    this.contactNumber = Product.channels.CAS.phone;
    this.hasAgent = true;
    this.workflowAction = `${this.policy.workflowState}:${this.policy.workflowSubState}`;
  }

  getPolicyStatusTitle(): string[] {
    const submittedTitle = [`Thank you for submitting your application.`];

    switch (this.workflowAction) {
      case 'Customer Confirm Application:Waiting for customer signature':
        return [`You're on your way to getting covered.`];
      case 'ID Check:Verifying':
        return submittedTitle;
      case 'Suitability:Reviewing':
        return submittedTitle;
      case 'Rejected:Suitability Rejected':
        return submittedTitle;
      case 'Approved:Offer ready to send':
        return submittedTitle;
      case 'Application:Waiting for Annuity Acceptance':
        return [`Congratulations, your annuity has been approved.`];
      case 'Issuance:Processing':
      case 'In Force:Issued':
        return [`Congratulations, you're covered!`];
      case 'Operations Review:Operations Review':
        return [`We need more time to review your application.`];
      default:
        UILoggerSingleton.getInstance().error(
          {
            module: 'CoverpathAnnuityStatus',
            function: 'getPolicyStatusTitle',
            category: UICategory.request,
            error: {
              data: {
                workflowAction: this.workflowAction,
              },
            },
          },
          `No policy status title found for workflow action \"${this.workflowAction}\"`
        );
        return [];
    }
  }

  async getPolicyStatusSubTitle(): Promise<string[]> {
    const reviewingApplicationSubTitle = [`We are reviewing your application, and you will hear from us soon.`];

    switch (this.workflowAction) {
      case 'Customer Confirm Application:Waiting for customer signature':
        return [`We just need your eSignature to finish reviewing your application.`];
      case 'ID Check:Verifying':
        return reviewingApplicationSubTitle;
      case 'Suitability:Reviewing':
        return reviewingApplicationSubTitle;
      case 'Rejected:Suitability Rejected':
        return reviewingApplicationSubTitle;
      case 'Approved:Offer ready to send':
        return reviewingApplicationSubTitle;
      case 'Application:Waiting for Annuity Acceptance':
        return [`Please note that your coverage will only begin if payment is received.`];
      case 'Issuance:Processing':
        return [
          `Your annuity is active. We're preparing your annuity documents and will email you as soon as they're ready.`,
          `You can view your annuity details below.`,
        ];
      case 'In Force:Issued':
        return ['Your annuity is active!', 'You can view your annuity details below.'];
      case 'Operations Review:Operations Review':
        return [``];
      default:
        UILoggerSingleton.getInstance().error(
          {
            module: 'CoverpathAnnuityStatus',
            function: 'getPolicyStatusSubTitle',
            category: UICategory.request,
            error: {
              data: {
                workflowAction: this.workflowAction,
              },
            },
          },
          `No policy status subtitle found for workflow action \"${this.workflowAction}\"`
        );
        return [];
    }
  }
}
